import React from 'react';
import { useTranslation } from 'react-i18next';

import { TDeleteGroupsProps } from '@/backoffice/features/groups/components/delete-groups/delete-groups.types';
import { useBackofficeGroupsResourcesCount } from '@/backoffice/features/groups/hooks/use-backoffice-groups-resources-count';
import { useDeleteBackofficeResourceGroupMutation } from '@/backoffice/redux/api/backoffice/backoffice-api';
import { ConfirmDelete } from '@/shared/components/ui/confirm-delete/confirm-delete';
import { Can } from '@/shared/features/permissions/components/can/can';

export const DeleteGroups: React.FC<TDeleteGroupsProps> = ({
  groupIds,
  onSuccess,
}) => {
  const { t } = useTranslation();
  const [deleteGroup] = useDeleteBackofficeResourceGroupMutation();
  const resourcesCount = useBackofficeGroupsResourcesCount(groupIds);

  const isLoadingCounts = groupIds.some((id) => resourcesCount[id]?.isLoading);
  const hasGroupWithResources =
    isLoadingCounts ||
    groupIds.some((id) => (resourcesCount[id]?.allResourcesCount ?? 0) > 0);

  const handleDelete = async () => {
    await Promise.all(
      groupIds.map((groupId) => deleteGroup({ groupId }).unwrap()),
    );
  };

  return (
    <Can action="backofficeGroup:deleteGroup" ids={groupIds}>
      <ConfirmDelete
        component="Button"
        disabled={hasGroupWithResources}
        tooltip={
          hasGroupWithResources
            ? t('groups:cannot_delete_group_with_subgroups')
            : undefined
        }
        deleteMutation={handleDelete}
        itemCount={groupIds.length}
        onSuccess={onSuccess}
      />
    </Can>
  );
};
